import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";


import { Accordion, AccordionTab } from "primereact/accordion";

import LoadingDialog from "../Utils/LoadingDialog";
import withName from "../../hoc/withName";
import { RestAPI } from "@aws-amplify/api-rest";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import { FilterMatchMode } from "primereact/api";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const BilingDocuments = () => {

    const { t, i18n } = useTranslation();
    const { hub, date } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [clientKeys, setClientKeys] = useState([]);
    const [integratorsKeys, setIntegratorsKeys] = useState([]);
    const [farms, setFarms] = useState([]);

    useEffect(() => {
        if(hub && date){
            RestAPI.get("apiAdminDropControl","/billing/documents",
                {queryStringParameters: {"hub_id":hub, "date":date}}).then(async (response) => {
                const clients = [];
                const integrators = [];
                Object.keys(response?.clients)?.forEach(n => {
                    clients.push({...response.clients[n], name:n});
                });
                Object.keys(response?.integrators)?.forEach(n => {
                    integrators.push({...response.integrators[n], name:n});
                });
                clients.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });
                integrators.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });
                setClientKeys(clients);
                setIntegratorsKeys(integrators);
                setFarms(response?.farms);
                setIsLoading(false);
            })
                .catch((error) => {
                    if (error.response.status === 403) {
                        toast.error(t("billing.403DocError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    }
                    setIsLoading(false);
                    console.log(error);
                });
        }
    },[hub, date]);

    const downloadTemplate = (rowData, type) =>{
        /*return (<ButtonPrime label={t("billing.back")} onClick={() => {
            window.open(rowData[type], "_blank")
        }} raised>
            <FontAwesomeIcon  icon={faDownload} size="lg" />
        </ButtonPrime>);*/
        return (<><a href={rowData?.full}>Full</a> / <a href={rowData?.summary}>{`${t("farms.summary")}`}</a></>);
    };
    return (
        <>
            {
                isLoading?
                    <div className='row-container'>
                        <LoadingDialog />
                    </div>
                    :<div className='row-container'>
                        <div className='row'>
                            <div className="col-sm-12 col-lg-12">
                                <div id="cardRaw" className="card">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col col-sm-2 col-md-3 col-lg-3' />
                                            <div className='col col-sm-10 col-md-8 col-lg-6 text-center'>
                                                <h5 className="card-title"><span>{t("billing.documentsTitle")}</span></h5>
                                            </div>
                                        </div>
                                        <div className='linea-titulo' />
                                        <Accordion multiple activeIndex={[0]}>
                                            <AccordionTab header={
                                                <div className="flex justify-content-between flex-nowrap p-accordion-header-text">
                                                    <i className="pi pi-file-excel pl-4 pr-4" />
                                                    <span className="pr-6 font-normal">
                                                        {t("billing.integratorsDocs")}
                                                    </span>
                                                </div>
                                            }
                                            >
                                                <p className="m-0">
                                                    {
                                                        integratorsKeys.length>0?
                                                            <DataTablePrime
                                                                style={{paddingLeft:"1.5rem"}}
                                                                t={t}
                                                                header={integratorsKeys.length>10?"search":null}
                                                                items={integratorsKeys}
                                                                scrollHeight="55vh"
                                                                filters={{
                                                                    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
                                                                }}
                                                                size="small"
                                                                globalFilterFields={["name"]}
                                                                fields={[
                                                                    {field:"name",header:t("sass.integrator"), bodyStyle:{textAlign:"center"}},
                                                                    {field:"links",header:t("billing.reports"), body:downloadTemplate, bodyStyle:{textAlign:"center"}},
                                                                ]}
                                                            />:<p className='ml-4'>{t("billing.noDocs")}</p>
                                                    }
                                                </p>
                                            </AccordionTab>
                                            <AccordionTab header={
                                                <div className="flex justify-content-between flex-nowrap p-accordion-header-text">
                                                    <i className="pi pi-file-excel pl-4 pr-4" />
                                                    <span className="pr-6 font-normal">
                                                        {t("billing.directClientsDocs")}
                                                    </span>
                                                </div>
                                            }
                                            >
                                                <p className="m-0">
                                                    {
                                                        clientKeys.length>0?
                                                            <DataTablePrime
                                                                style={{paddingLeft:"1.5rem"}}
                                                                t={t}
                                                                header={clientKeys.length>10?"search":null}
                                                                items={clientKeys}
                                                                scrollHeight="55vh"
                                                                filters={{
                                                                    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
                                                                }}
                                                                size="small"
                                                                globalFilterFields={["name"]}
                                                                fields={[
                                                                    {field:"name",header:t("billing.client"), bodyStyle:{textAlign:"center"}},
                                                                    {field:"links",header:t("billing.reports"), body:downloadTemplate, bodyStyle:{textAlign:"center"}},
                                                                ]}
                                                            />:<p className='ml-4'>{t("billing.noDocs")}</p>
                                                    }
                                                </p>
                                            </AccordionTab>
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>
    );
};

export default withName(BilingDocuments, "BilingDocuments");
